import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countBatchJobs'
})
export class countBatchJobsPipe implements PipeTransform {
  transform(items: any[]): number {
    let count = 0;
    for (let item of items) {
      if(item.jobs) {
        for (let subAssembly of item.jobs) {
          if(subAssembly.jobsList) {
            count += subAssembly.jobsList.length;
          }
        }
      }
    }
    return count;
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/count-batch-jobs.pipe.ts